export default function discountTransformer(discount) {
  return discount ? discount.name : ''
}
